<template>
  <div>
    <div
      style="
        position: relative;
        border: gold 1px solid;
        z-index: 0;
        width: 160px;
        height: 160px;
        overflow: hidden;
        margin-top: 10px;
        margin-left: 10px;
      "
      class="ma-12 grid"
    >
      <v-avatar class="" size="130" style="z-index: 0">
        <v-img
          class="flower"
          :src="this.$store.getters.user.avatar"
          style="position: relative; z-index: -1"
        >
        </v-img>
      </v-avatar>
      <v-btn
        class="mx-2"
        fab
        dark
        small
        color="pink"
        style="z-index: 70 !important; position: absolute; left: 0; bottom: 0"
      >
        <v-icon dark> mdi-heart </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        dark
        small
        color="pink"
        style="position: absolute; right: 0; bottom: 0; z-index: 2"
      >
        <v-icon dark> mdi-heart </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
